function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  y1: 0.5,
  x2: 1,
  y2: 0.5,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#da0000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9f0000"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-353.704 -2995.375)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M386.487,2995.747a10.885,10.885,0,0,1,7.342.611h0a10.9,10.9,0,0,0,9.042,0h0a10.9,10.9,0,0,1,13.395,3.589h0a10.9,10.9,0,0,0,7.831,4.521h0a10.9,10.9,0,0,1,9.805,9.806h0a10.9,10.9,0,0,0,4.521,7.83h0a10.9,10.9,0,0,1,3.589,13.4h0a10.9,10.9,0,0,0,0,9.042h0a10.9,10.9,0,0,1-3.589,13.4h0a10.9,10.9,0,0,0-4.521,7.831h0a10.9,10.9,0,0,1-9.805,9.8h0a10.9,10.9,0,0,0-7.831,4.521h0a10.9,10.9,0,0,1-13.395,3.589h0a10.909,10.909,0,0,0-9.042,0h0a10.9,10.9,0,0,1-13.4-3.589h0a10.9,10.9,0,0,0-7.83-4.521h0a10.9,10.9,0,0,1-9.806-9.8h0a10.9,10.9,0,0,0-4.521-7.831h0a10.9,10.9,0,0,1-3.589-13.4h0a10.9,10.9,0,0,0,0-9.042h0a10.9,10.9,0,0,1,3.589-13.4h0a10.9,10.9,0,0,0,4.521-7.83h0a10.9,10.9,0,0,1,9.806-9.806h0a10.9,10.9,0,0,0,7.83-4.521h0A10.884,10.884,0,0,1,386.487,2995.747Z",
  fill: "url(#a)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37.182,
  cy: 37.182,
  r: 37.182,
  transform: "translate(361.168 3002.838)",
  fill: "none",
  stroke: "#fbb03b",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M396.691,3017.9a1.873,1.873,0,0,0-3.746,0v41.481h3.744V3017.9Z",
  fill: "#fbb03b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M399.819,3061.9h-10a4.131,4.131,0,0,0-4.129,4.132h18.258A4.127,4.127,0,0,0,399.819,3061.9Z",
  fill: "#fbb03b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M411.565,3025.514l-12.286-4.735v18.937l12.286-4.736,12.286-4.731Z",
  fill: "#fbb03b"
}));

var SvgFlag = function SvgFlag(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89.291,
    height: 89.29,
    viewBox: "0 0 89.291 89.29",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFlag, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/flag.86df43fb.svg";
export { ForwardRef as ReactComponent };